import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_INDUSTRIAL_ACTIVITY_IMPACTS_PATH,
  GetOrganizationIndustrialActivityImpactsErrorDto,
  GetOrganizationIndustrialActivityImpactsSuccessDto,
} from '@/api/rest/resources/types/industry';
import { usePlotGroupId } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { useWorkstreamId } from '@/pages/shared/home/hooks/useWorkstreamId';
import { useNCAParentOrganizationId } from '@/pages/shared/hooks/useNCAParentOrganizationId';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

type SuccessDto = GetOrganizationIndustrialActivityImpactsSuccessDto;
type ErrorDto = GetOrganizationIndustrialActivityImpactsErrorDto;

export const useOrganizationIndustrialActivityImpactScores = (plotGroupIdArg?: string | null) => {
  const plotGroupId = usePlotGroupId();
  const workstreamId = useWorkstreamId();

  const ncaParentId = useNCAParentOrganizationId();
  const organizationId = useOrganizationId();
  const orgId = organizationId ?? ncaParentId;

  const pathVariables = { organization_id: orgId };
  const queryParams = {
    plot_group_id: plotGroupIdArg ?? plotGroupId,
    ...(ncaParentId ? { nca_parent_id: ncaParentId } : {}),
    ...(workstreamId ? { workstream_id: workstreamId } : {}),
  };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_ORGANIZATION_INDUSTRIAL_ACTIVITY_IMPACTS_PATH, pathVariables, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', pathVariables, 'industrial-activity', 'impacts', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
